export default {"src":"/_next/static/media/kelas-live-section-ongoing.60e9f024.svg","height":438,"width":1440,"blurWidth":0,"blurHeight":0};